<template>
  <div class="box">

    <div class="columns">

      <div class="column is-two-thirds">

        <!-- the new post title -->
        <div class="field">
          <label class="label">Books's title</label>
          <div class="control">
            <input type="text" class="input" placeholder="Title" v-model="post.title">
          </div>
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">Synopsis</label>
        <quill-editor v-model="post.synopsis" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <label class="label">Excerpt</label>
        <quill-editor v-model="post.excerpt" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">About Author</label>
        <quill-editor v-model="post.author_text" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- Category field -->
        <!-- <br>
        <div class="field">
          <label class="label">Category</label>
          <div class="control">
            <input type="text" class="input" placeholder="Category" v-model="post.category" maxlength="25">
          </div>
        </div> -->

      </div>

      <!-- new post right sidebar -->
      <div class="column is-one-third">

        <div class="columns">
        <div class="column is-half">
        <!-- price -->
        <div class="field">
          <label class="label">Price Paper</label>
          <div class="control">
            <input type="text" class="input" placeholder="price for paper" v-model="post.price_paper" maxlength="25" required>
            <p></p>
          </div>
        </div>
        </div>
        <div class="column is-half">
        <div class="field">
          <label class="label">Price Ebook</label>
          <div class="control">
            <input type="text" class="input" placeholder="price for ebook" v-model="post.price_ebook" maxlength="25" required>
            <p></p>
          </div>
        </div>
      </div>
    </div>

        <div class="columns">
        <div class="column is-one-third">
        <!-- year -->
        <div class="field">
          <label class="label">Year</label>
          <div class="control">
            <input type="text" class="input" placeholder="year" v-model="post.year" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>

       <div class="column is-one-third">
        <div class="field">
          <label class="label">Original Year</label>
          <div class="control">
            <input type="text" class="input" placeholder="original publishing year" v-model="post.original_year" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>
       </div>

        <!-- pages_words -->
        <div class="field">
          <label class="label">Pages</label>
          <div class="control">
            <input type="text" class="input" placeholder="pages" v-model="post.pages" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <!-- author -->
        <!-- <div class="field">
          <label class="label">Author</label>
          <div class="control">
            <input type="text" class="input" placeholder="Author" v-model="post.author" maxlength="25" required>
            <p></p>
          </div>
        </div> -->

        <!-- editor -->
        <div class="field">
          <label class="label">Editor</label>
          <div class="control">
            <input type="text" class="input" placeholder="Editor" v-model="post.editor" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <div class="field">
          <label class="label">Original</label>
          <div class="control">
            <input type="text" class="input" placeholder="Original Text Info" v-model="post.original" maxlength="200" required>
            <p></p>
          </div>
        </div>

        <!-- ortografia -->
        <div class="field">
          <label class="label">Ortografia</label>
          <div class="control">
            <input type="text" class="input" placeholder="OO: Ort. orig. | OA: Ort. act. (1945) | AO: Novo acordo ort. (1990)" v-model="post.orthography" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <div class="field">
          <label class="label">Rev.</label>
          <div class="control">
            <input type="text" class="input" placeholder="Revision" v-model="post.rev" maxlength="25" required>
            <p></p>
          </div>
        </div>
        <div class="field">
          <label class="label">Cover</label>
          <div class="control">
            <input type="text" class="input" placeholder="CoverInfo" v-model="post.cover_info" maxlength="100" required>
            <p></p>
          </div>
        </div>

        <!-- authors -->
        <div class="field">
          <label class="label">Authors</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeAuthor(index)" v-for="(aut, index) in post.authors" :key="index" class="tag is-info pointer">{{aut}}<button class="delete is-small"></button></span>
            <input placeholder="Authors" @keypress.44.prevent="styleAuthors" @keyup.enter="styleAuthors" type="text" class="input" maxlength="25" v-model="inputDataAuthors">
            </div>
            <p>Separate authors with ENTER</p>
          </div>
        </div>

        <!-- categories -->
        <div class="field">
          <label class="label">Categories</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeCategory(index)" v-for="(cat, index) in post.categories" :key="index" class="tag is-info pointer">{{cat}}<button class="delete is-small"></button></span>
            <input placeholder="Categories" @keypress.44.prevent="styleCategories" @keyup.enter="styleCategories" type="text" class="input" maxlength="25" v-model="inputDataCategories">
            </div>
            <p>Separate Categories with ENTER</p>
          </div>
        </div>

        <!-- tags -->
        <!-- <div class="field">
          <label class="label">Tags</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeTag(index)" v-for="(tag, index) in post.tags" :key="index" class="tag is-info pointer">{{tag}}<button class="delete is-small"></button></span>
            <input placeholder="Tags" @keypress.44.prevent="styleTags" @keyup.enter="styleTags" type="text" class="input" maxlength="25" v-model="inputData">
            </div>
            <p>Seperate tags with commas</p>
          </div>
        </div> -->

        <div class="field">
          <label class="label">Cover (100x100px)</label>
          <div class="control">
            <img :src="post.cover">
            <div class="file">
              <label class="file-label">
                <input @change="uploadFeaturedImage" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">PDF</label>
          <div class="control">
            <a v-if="post.file_pdf" :href="post.file_pdf">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadPDF" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">EPub</label>
          <div class="control">
            <a v-if="post.file_epub" :href="post.file_epub">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadEpub" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

      </div> <!-- Right Sidebar -->

    </div>

    <hr>

    <!-- Full Text Editor -->
    <div class="columns">
      <div class="column">
        <!-- rich text vue-quill-editor plugin -->
        <label class="label">Full Text <a style="float: right" href="#bottom">Bottom ↓</a></label>
        <quill-editor id="full-text" class="full-text" v-model="fulltext" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
      </div>
    </div>

    <!-- warning notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <!-- the form buttons -->
    <a id="bottom"/>
    <button v-if="post.state === 'saved'" type="submit" class="button is-success" @click="update(true)">Update and publish</button>
    <button id="save_button" type="submit" class="button is-info" @click="update(false)">Update</button>
    <button id="export_button" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportPDF(post, fulltext)">Export PDF</button>
    <button id="export_button_ebook" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportPDF(post, fulltext, true)">Export eBook PDF</button>
    <button id="export_button_ebook" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportEPub(post, fulltext, true)">Export eBook ePub</button>
    <router-link to="/admin/books" class="button is-danger">Cancel</router-link>
    <AsyncComponent ref="asyncComponentRef" />
  </div>
</template>

<script>
import firebase from 'firebase'
import utils from '@/mixins/utils'

import { mediaRef, textsRef } from '@/firebase_config'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'
import notifier from '@/mixins/notifier'

export default {
  name: 'post-edit',
  components: {
    AsyncComponent: () => import('./AsyncComponent.vue')
  },
  data () {
    var self = this
    textsRef.child(this.$route.params.key).child('text').once('value').then(function (textSnapshot) {
      self.fulltext = self.fixDiacritics(textSnapshot.val())
    })
    return {
      /* Here we are filtering out the post containing the provided key in the router params
       * we are using Object.assign to copy the post by value not by reference
       * to prevent updating the poste when typing */
      inputData: '',
      inputDataCategories: '',
      inputDataAuthors: '',
      fulltext: '',
      post: Object.assign(
        {},
        (this.posts.filter((post) => {
          return (post['.key'] === this.$route.params.key)
        }))[0]
      ),
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['posts', 'texts', 'update-post'],
  mixins: [utils, imageLoader, notifier, textsRef],
  methods: {
    exportPDF () {
    },
    // call the updatePost method passed through props
    update (publish) {
      if (this.post.title) {
        if (publish) {
          this.post.state = 'published'
        }
        this.updatePost(this.post, this.fulltext)
      } else {
        this.showNotification('warning', 'The title field can not be empty')
      }
    },
    uploadFeaturedImage (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.post.cover = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    uploadPDF (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/pdf/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.post.file_pdf = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    uploadEpub (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/epub/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.post.file_epub = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleAuthors () {
      if (this.inputDataAuthors !== '') {
        this.post.authors.push(`${this.inputDataAuthors.trim()}`)
        this.inputDataAuthors = ''
      }
    },
    removeAuthor (index) {
      this.post.authors.splice(index, 1)
    },
    styleCategories () {
      if (this.inputDataCategories !== '') {
        this.post.categories.push(`${this.inputDataCategories.trim()}`)
        this.inputDataCategories = ''
      }
    },
    removeCategory (index) {
      this.post.categories.splice(index, 1)
    },
    styleTags () {
      if (this.inputData !== '') {
        this.tagString.push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index) {
      this.tagString.splice(index, 1)
    }
  },
  updated: function () {
    var elements = document.getElementsByTagName('p')
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].innerHTML.indexOf('<img') === 0) {
        elements[i].firstElementChild.classList.add('full-img')
      }
      // elements[i].innerHTML = elements[i].innerHTML.replace(/\\b([a-z])([a-z]+)?\\b/gim, "<span class='first-letter'>$1</span>$2")
    }
  },
  mounted: function () {
    // init arrays if empty
    if (!this.post.categories) this.post.categories = []
    if (!this.post.authors) this.post.authors = []
  },
  computed: {
    tagString: {
      get: function () {
        return this.post.tags // if no tags present join is undefined
      },
      set: function (newValue) {
        this.post.tags = newValue
      }
    }
  }
}
// show full text edit toolbar at top
window.onscroll = function (e) {
  // called when the window is scrolled.
  var fullText = document.getElementById('full-text')
  if (fullText) {
    var targetDiv = document.getElementById('full-text').getElementsByClassName('ql-toolbar')[0]
    if (document.body.scrollTop > 450 || document.documentElement.scrollTop > 450) {
      targetDiv.classList.add('ql-toolbar-fixed')
    } else {
      targetDiv.classList.remove('ql-toolbar-fixed')
    }
  }
}
// save and export keyboard shortcuts
document.addEventListener('keydown', function (event) {
  if (event.code === 'KeyS' && (event.ctrlKey || event.metaKey)) {
    event.preventDefault()
    document.querySelector('#save_button').click()
    console.log('Saved!')
  } else if (event.code === 'KeyE' && (event.ctrlKey || event.metaKey)) { // export PDF
    document.querySelector('#export_button').click()
  }
})
</script>
<style>
.label {
    border-bottom: 1px solid #f2f2f2;
}
.tagscontainer {
  border: 2px solid #f2f2f2;
  border-radius: 5px;
  padding: 5px;
}
.pointer {
  cursor: pointer;
}
.ql-toolbar-fixed {
  margin-bottom: 100px;
  margin-top: 48px;width: 100%;
  top: 0;
  z-index: 100;
  position: fixed;
  background: white;
}
.ql-container.ql-snow {
    border: 0px;
}
.ql-editor {
  margin-left: auto;
  margin-right: auto;
  max-width: 600px;
}
.full-img {
  width: 100% !important;
}
.ql-editor p img {
  width: 20px;
}
#full-text .ql-size-small {
  font-size: 0.90em;
}
#full-text .ql-container {
  font-size: 120%;
  font-family: Georgia,Cambria,"Times New Roman",Times,serif;
}
#full-text p {
  margin-bottom: 16px;
  text-align: justify;
}
#full-text .ql-align-center {
    text-align: center !important;
}
#full-text .ql-align-right {
    text-align: right !important;
}
#full-text h2 {
  margin-top: 120px;
  margin-bottom: 30px;
}
#full-text h3 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/BookEdit.vue